import * as DialogPrimitive from '@radix-ui/react-dialog';

function ModalTrigger(props: DialogPrimitive.DialogTriggerProps) {
  return <DialogPrimitive.DialogTrigger {...props} />;
}

export { ModalTrigger };
